import { render } from "./ReservsClients.vue?vue&type=template&id=3c73c1a2&scoped=true"
import script from "./ReservsClients.vue?vue&type=script&lang=js"
export * from "./ReservsClients.vue?vue&type=script&lang=js"

import "./ReservsClients.vue?vue&type=style&index=0&id=3c73c1a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c73c1a2"]])

export default __exports__